import React, { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import {
  FiMenu,
  FiBriefcase,
  FiClipboard,
  FiList,
  FiUsers,
  FiGlobe,
} from "react-icons/fi";
import { LuGoal } from "react-icons/lu";
import { MdPersonSearch, MdLibraryBooks } from "react-icons/md";
import { FaRegNewspaper } from "react-icons/fa6";
import { BsEnvelopeArrowUp } from "react-icons/bs";
import { FaBlog, FaRegAddressBook, FaBookmark } from "react-icons/fa";
import { GrTemplate } from "react-icons/gr";
import "./sidebar.css";

export default function Sidebar({ collapsed = false, onToggle }) {
  const location = useLocation();
  const [hoveredGroup, setHoveredGroup] = useState(null);

  // Define groups and their paths
  const groups = [
    {
      name: "Career",
      icon: <LuGoal />,
      paths: ["/jobs", "/applications", "/categories", "/admins", "/hrs"],
      items: [
        { to: "/jobs", label: "Jobs", icon: <FiBriefcase /> },
        { to: "/applications", label: "Applications", icon: <FiClipboard /> },
        { to: "/categories", label: "Categories", icon: <FiList /> },
        { to: "/admins", label: "Admins", icon: <FiUsers /> },
        { to: "/hrs", label: "HR", icon: <MdPersonSearch /> },
      ],
    },
    {
      name: "Newsroom",
      icon: <FiGlobe />,
      paths: ["/news", "/subscribers"],
      items: [
        { to: "/news", label: "News", icon: <FaRegNewspaper /> },
        { to: "/subscribers", label: "Subscribers", icon: <BsEnvelopeArrowUp /> },
      ],
    },
    {
      name: "Blog",
      icon: <FaBlog />,
      paths: ["/blogs", "/topics", "/authors" ,"/templates"],
      items: [
        { to: "/topics", label: "Topics", icon: <FaBookmark /> },
        { to: "/authors", label: "Authors", icon: <FiUsers /> },
        { to: "/blogs", label: "Blogs", icon: <MdLibraryBooks /> },
        { to: "/templates", label: "Templates", icon: <GrTemplate/> },
      ],
    },
  ];

  // Determine active group based on current path
  const activeGroup = groups.find((group) =>
    group.paths.includes(location.pathname)
  )?.name;

  return (
    <aside
      className={`sidebar ${collapsed ? "collapsed" : ""}`}
      onMouseEnter={() => collapsed && setHoveredGroup(activeGroup || groups[0].name)}
      onMouseLeave={() => collapsed && setHoveredGroup(null)}
    >
      <div className="sidebar-top">
        <button className="collapse-btn" onClick={onToggle} aria-label="Toggle sidebar">
          <FiMenu />
        </button>
        <div className="brand">Admin</div>
      </div>

      <nav className="nav">
        {groups.map((group) => (
          <div
            key={group.name}
            className="nav-group"
            onMouseEnter={() => setHoveredGroup(group.name)}
            onMouseLeave={() => setHoveredGroup(activeGroup || null)}
          >
            <div className="nav-group-title">
              {group.icon} <span className="label">{group.name}</span>
            </div>
            {(hoveredGroup === group.name || activeGroup === group.name) && (
              <div className="nav-items">
                {group.items.map((item) => (
                  <NavLink key={item.to} to={item.to} className="nav-item">
                    {item.icon} <span className="label">{item.label}</span>
                  </NavLink>
                ))}
              </div>
            )}
          </div>
        ))}

      <NavLink to="/contacts" className="nav-item">
          <FaRegAddressBook /> <span className="label">Contact Forms</span>
        </NavLink>

        <NavLink to="/email-service" className="nav-item">
          <FaRegAddressBook /> <span className="label">Email Configurations</span>
        </NavLink>
      </nav>
      

      <div className="sidebar-footer">
        <small>© {new Date().getFullYear()}</small>
      </div>
    </aside>
  );
}